<template>
  <div class="asc-subscirption-center-template">
    <v-row no-gutters>
      <v-col cols="12" sm="12">
        <asc-subscription-center-grid-wrapper
          v-if="isSubscriptionCenterActive"
          :title="gidTitle"
          :values="values"
          v-on="$listeners"
        ></asc-subscription-center-grid-wrapper>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { AscGridPropsMixin } from '@/components/mixins'
import { AscSubscriptionCenterGridWrapper } from '@/components/organisms'
import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscSubscriptionCenterTemplate',

  components: {
    AscSubscriptionCenterGridWrapper,
  },

  mixins: [AscGridPropsMixin],

  props: {
    gidTitle: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    isSubscriptionCenterActive() {
      return AppFeatureFlags.getSubscriptionCenter()
    },
  },
}
</script>

<style lang="scss">
.asc-subscription-center-template {
  background-color: $primary-white;

  &--description {
    color: $primary-black;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 18px;
    margin: 13px 0 26px 0;
    display: inline-block;
    width: 100%;
  }
}
</style>
